@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.admin.analytics

import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.analytics.AnalyticsConfigDto

object UpsertAnalyticsSettingsEndpoint : EndPoint<UpsertAnalyticsSettingsEndpoint.Request, UpsertAnalyticsSettingsEndpoint.Response>() {
    class Request(val settings: AnalyticsConfigDto)
    class Response(val settings: AnalyticsConfigDto)
}
